import React from 'react'

import { Avatar, Badge, Collapse, Divider, Typography } from 'antd'
import { CloseCircleOutlined } from '@ant-design/icons'

const { Panel } = Collapse
const { Paragraph } = Typography

const PanelTitle = (props) => (
  <>
    <Avatar src={props?.icon} shape='square' />
    <Divider type='vertical' />
    {props?.text}
  </>
)

const CustomPanel = (props) => {
  const createBadge = (num) => <Badge count={num} showZero />

  const { count, type, title, loading, error, children } = props
  const noData = count === 0

  if (noData) {
    return null
  }
  return (
    <>
      <Collapse expandIconPosition='right'>
        <Panel
          header={<PanelTitle text={title} icon={props.icon} />}
          extra={createBadge(count)}
          className='custom-collpase-panel'
        >
          {error && (
            <Paragraph>
              <CloseCircleOutlined style={{ color: 'red' }} /> Somes problems occurs please try again in a
              few minutes.
            </Paragraph>
          )}
          {!error && !noData && children}
        </Panel>
      </Collapse>
    </>
  )
}

export default CustomPanel
